import { CoreApi, DoorOpeningDirectionComponent, PartKey } from '@inter-ikea-storageone/range';
import {
  Entity,
  GuestConnectionsComponent,
  ComponentIds,
  HierarchyUtils,
  ProductPartComponent,
  Nullable
} from '@inter-ikea-core/core';
import { DoorNextToCornerSolutionComponent } from '@inter-ikea-storageone/range-pax';

export const getCurrentDoorOpeningDirection = (entity: Nullable<Entity>) => {
  if (!entity) return '';

  const connection = entity.getComponent<GuestConnectionsComponent>(
    ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID
  )?.highestPriorityConnection?.hostConnector.key;

  return connection && connection.includes('right') ? 'right' : 'left';
};

export const disableChangeOpeningDirection = (door: Nullable<Entity>) => {
  return door?.hasComponent(DoorNextToCornerSolutionComponent.id);
};

export const changeDoorDirection = (
  doorEntity: Nullable<Entity>,
  coreApi: CoreApi,
  config: {
    frameLeftSeriesConnector: string;
    frameRightSeriesConnector: string;
    frontConnectorLeft: string;
    frontConnectorRight: string;
  }
) => {
  const {
    frameLeftSeriesConnector,
    frameRightSeriesConnector,
    frontConnectorLeft,
    frontConnectorRight
  } = config;
  if (!doorEntity) return;

  // SelectedEntity should be a front, here we get the frame assembly from the front
  const frameAssembly = HierarchyUtils.findWithComponentInUpwardsHierarchy(
    doorEntity,
    ComponentIds.FRAME_COMPONENT_ID
  );

  if (!frameAssembly) return;

  // Second step is to get the actual frame from the frameAssembly to be able to find valid connectors
  const frame =
    HierarchyUtils.children(frameAssembly).find(
      e =>
        e.getComponent<ProductPartComponent>(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey ===
        PartKey.FRAME
    ) || frameAssembly;

  if (!frame) return;

  const openingDirectionData = frame.getComponent<DoorOpeningDirectionComponent>(
    DoorOpeningDirectionComponent.id
  );

  const currentConnection = doorEntity.getComponent<GuestConnectionsComponent>(
    ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID
  )?.highestPriorityConnection;

  if (!currentConnection) return;

  const newFrameConnectorKey = currentConnection.hostConnector.key.includes(
    frameLeftSeriesConnector
  )
    ? currentConnection.hostConnector.key.replace(
        frameLeftSeriesConnector,
        frameRightSeriesConnector
      )
    : currentConnection.hostConnector.key.replace(
        frameRightSeriesConnector,
        frameLeftSeriesConnector
      );
  if (openingDirectionData) {
    openingDirectionData.doorFrameConnectorKeys = [newFrameConnectorKey];
  }

  const newDoorConnectorKey = currentConnection.guestConnector.key.includes(frontConnectorLeft)
    ? frontConnectorRight
    : frontConnectorLeft;

  const placementResult = coreApi.placementService.snapToConnector(
    doorEntity,
    newDoorConnectorKey,
    frame,
    newFrameConnectorKey
  );
  if (placementResult.valid) {
    const handle = HierarchyUtils.descendants(doorEntity).find(e =>
      e.hasComponent(ComponentIds.HANDLE_COMPONENT_ID)
    );
    if (handle) {
      // Resnap handles so that handing handles get's correct rotation
      coreApi.entities.resnapEntity(handle);
    }
  }
};
